import React from 'react'
import RouterSecondaryExpanded from '../../../components/RouterSecondaryExpanded'

const categorySubSections = {
  cars: [
    { label: 'New', slug: '/cars/new' },
    { label: 'Used', slug: '/cars/used' },
    { label: 'Offers', slug: '/cars/offers' },
    { label: 'Bodyshop', slug: '/bodyshop' },
    { label: 'Servicing', slug: '/servicing' }
  ],
  vans: [
    { label: 'New', slug: '/vans/new' },
    { label: 'Used', slug: '/vans/used' },
    { label: 'Offers', slug: '/vans/offers' },
    { label: 'Bodyshop', slug: '/bodyshop' },
    { label: 'Servicing', slug: '/servicing' }
  ]
}

const SubNavigationWidget = ({ category }) => {
  const subSections =
    category === 'vans' ? categorySubSections.vans : categorySubSections.cars

  return <RouterSecondaryExpanded sections={subSections} />
}

export default SubNavigationWidget
